import React from 'react';
import { LockIcon } from 'lucide-react';
interface ModuleCardProps {
  title: string;
  icon: React.ReactNode;
  description: string;
  status: 'active' | 'inactive' | 'warning';
  compact?: boolean;
  locked?: boolean;
}
export function ModuleCard({
  title,
  icon,
  description,
  status,
  compact = false,
  locked = false
}: ModuleCardProps) {
  return <div className={`relative overflow-hidden bg-white rounded-xl shadow-sm border border-gray-100 
      transition-all duration-300 hover:shadow-md
      ${status === 'inactive' ? 'opacity-60 grayscale' : status === 'warning' ? 'border-amber-200' : ''}
      ${compact ? 'p-4' : 'p-6'}`} data-id="element-843">
      {locked && <div className="absolute top-3 right-3 bg-blue-100 p-1 rounded-full" data-id="element-844">
          <LockIcon size={16} className="text-blue-600" data-id="element-845" />
        </div>}
      <div className="flex items-start gap-4" data-id="element-846">
        <div className={`rounded-lg p-2 ${status === 'warning' ? 'bg-amber-100' : 'bg-[#8DC63F]/10'}`} data-id="element-847">
          {icon}
        </div>
        <div className="flex-1" data-id="element-848">
          <h3 className={`font-semibold text-gray-800 ${compact ? 'text-base' : 'text-lg'}`} data-id="element-849">
            {title}
          </h3>
          {!compact && <p className="text-sm text-gray-500 mt-1" data-id="element-850">{description}</p>}
          {status === 'warning' && <div className="flex items-center mt-2" data-id="element-851">
              <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse mr-2" data-id="element-852"></div>
              <span className="text-xs text-amber-700" data-id="element-853">Warnung</span>
            </div>}
        </div>
      </div>
    </div>;
}